import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import LeaseDocumentTable from "./LeaseDocumentTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import { ViewLeasePdfReader } from "../../utils/ViewLeaseDocumentViewer";
import {
  faPen,
  faPlus,
  faEye,
  faTimes,
  faUndo,
  faDownload,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { getUserType } from "../../utils/index";
if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),
    // leaseId: Yup.number()
    //   .required("Required")
    //   .transform((value) => (isNaN(value) ? undefined : value))
    //   .nullable(),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // brandId: Yup.number().required("Required"),
    // leaseId: Yup.number()
    //   .required("Required")
    //   .transform((value) => (isNaN(value) ? undefined : value))
    //   .nullable(),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    // leaseId: Yup.number()
    //   .required("Required")
    //   .transform((value) => (isNaN(value) ? undefined : value))
    //   .nullable(),
  });
}

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseDocumentation extends React.Component {
  groupId = { value: "" };
  state = {
    url: `${apiUrl.apiUrl.url}/lease-report`,
    LandlordGroups: [],
    landloardList: [],
    occupierList: [],
    countries: [],
    districtList: [],
    cityList: [],
    brandCatList: [],
    brandList: [],
    assetsList: [],
    assetTypeList: [],
    assetTypeSelected: [],
    leaseList: [],
    leaseDocumentTypeList: [],
    brandSelected: [],

    leaseSelected: [],
    redirect: false,
    states: [],
    zones: [],
    redirect: false,
    id: undefined,
    selectedBrand: "",
    counter: 0,
    selectedAsset: "",
    leaseMonths: monthsArr,
    currentDocument: "",
    pageNo: 1,
    leaseTypes: [],
    initialValues: {
      brandId: "",
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      brandCatId: "",
      landloardName: "",
      landloardId: "",
      OccupierName: "",
      occupierId: "",
      leaseDocumentTypeId: "All",
      leaseId: "",
      modelValue: 'All',
      modelId: 'All',
      leaseNumber: "",
      assetTypeId: "",
    },
    gridColumns: [
      {
        name: "S.No",
        selector: "srNo",
        sortable: false,
        grow: 1,
      },
      {
        name: "Asset Name",
        selector: "assetName",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Brand Name / Occupier Name",
        selector: "brandName",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Lease Id",
        selector: "leaseCode",
        sortable: false,
        grow: 3,
        wrap: true,
        width: 300,
        //grow: 5,
      },
      {
        name: "Unit No",
        selector: "unit_no",
        sortable: false,
        grow: 3,
        wrap: true,
        cell: (record) => {
          if (typeof record.unit_no == "undefined" || record.unit_no == null) {
            return "-";
          } else {
            return (
              <div>
                {record.unit_no.map((anObjectMapped, index) => {
                  return <div> {anObjectMapped} </div>;
                })}
              </div>
            );
          }
        },
      },
      {
        name: "Gross Leasable Area",
        selector: "gross_leasable_area",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Cost Center",
        selector: "costCenter",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Model Type",
        selector: "modelType",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Document Type",
        selector: "leaseDocumentType",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Document Date",
        selector: "leaseUploadDocumentDate",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Action",
        grow: 2,
        // selector: "info",
        sortable: false,
        cell: (record) => {
          if (
            typeof record.documentUrl == "undefined" ||
            record.documentUrl == null || record.documentUrl === ""
          ) {
            return "-";
          } else {
            return (
              <div>
                {
                  <>
                    <span className="tableActionEdit">
                      <a href={`${record.documentUrl}`} target="_blank">
                        {" "}
                        <FontAwesomeIcon icon={faDownload} />
                      </a>
                    </span>
                    {

                      record.uploadDocType == "pdf" &&
                      <span className="tableActionEdit">
                        <a href="javascript:void(0)" target="_blank" onClick={(e) => {
                          e.preventDefault();
                          this.state.currentDocument = record.documentUrl;
                          console.log(record.documentUrl, "record.documentUrl");
                          this.state.pageNo = 1;
                          this.openModal();
                        }} >
                          {" "}
                          <FontAwesomeIcon icon={faEye} />
                        </a>
                      </span>
                    }

                  </>
                }
              </div>
            );
          }
        },
      },
      {
        name: "Storage Link",
        grow: 2, //leaseUploadDocumenURL
        cell: (record) => {
          if (
            typeof record.leaseUploadDocumenURL == "undefined" ||
            record.leaseUploadDocumenURL == null || record.leaseUploadDocumenURL === ""
          ) {
            return "-";
          } else {
            return (
              <div>
                {
                  <>

                    <a href={`${record.leaseUploadDocumenURL}`} target="_blank">
                      {" "}
                      View
                    </a>

                    {/* href={`${record.documentUrl}`} */}
                  </>
                }
              </div>
            );
          }
        },
      }
    ],
  };

  componentDidMount() {
    this.initialiseAllData();
    
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
  }


  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  initialiseAllData = () => {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-view/get-lease-document-type`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseDocumentTypeList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-occupier-landloard`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          landloardList: data.landloardList,
          occupierList: data.occupierList,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    fetch(`${apiUrl.apiUrl.url}/lease-report/fetch-lease-types`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
    this.getAssetTypes();
  }

  getAssetTypes = () => {
    let self = this;
    axios({
      method: 'GET',
      url: `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-with-filters?city_id=${this.state.initialValues.cityId}&brand_ids=${this.state.initialValues.brandId}
      `,
      headers: headers
    }).then((response) => {
      self.setState({
        assetTypeList: response.data
      });
    });
  }

  getAssetsListByAssetType = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-asset-lists?asset_type_ids=
      ${this.state.initialValues.assetTypeId}&city_id=${this.state.initialValues.cityId}&brand_ids=${this.state.initialValues.brandId}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  setMasterPreValues = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-select-asset-details?assetId=` +
      input,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data.countries,
          districtList: data.district,
          states: data.state,
          cityList: data.cities,
        });
        this.state.initialValues.stateId = data.data.stateId.stateId;
        this.state.initialValues.state_name = data.data.stateId.state_name;
        this.state.initialValues.cityId = data.data.cityId.cityId;
        this.state.initialValues.cityName = data.data.cityId.cityName;
        this.state.initialValues.districtId = data.data.districtId.districtId;
        this.state.initialValues.districtName =
          data.data.districtId.districtName;
        this.state.initialValues.countryId = data.data.countryId.countryId;
        this.state.initialValues.countryName = data.data.countryId.countryName;
        if (
          this.state.initialValues.brandId.length == 0 ||
          this.state.initialValues.brandId == ""
        ) {
          this.state.initialValues.brandCatId = data.data.catId;
          this.state.initialValues.brandCatName = data.data.cat_name;
          this.state.brandList = data.brandList;
          this.state.brandSelected = [
            { value: data.data.brandId, label: data.data.brand_name },
          ];
          // this.state.initialValues.brandId = [data.data.brandId];
        }
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.districtId = "";
      this.state.initialValues.districtName = "";
      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      this.state.initialValues.assetId = "";
      this.state.initialValues.assetName = "";

      fetch(
        `${apiUrl.apiUrl.url}/district/state-districts?state_id=` +
        newValue.value, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            districtList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_district") {
      this.state.initialValues.districtId = newValue.value;
      this.state.initialValues.districtName = newValue.label;

      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            cityList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "brand_category") {
      this.state.initialValues.brandCatId = newValue.value;
      this.state.initialValues.brandCatName = newValue.label;

      this.state.initialValues.brandId = "";
      this.state.initialValues.brandName = "";
      //get-brand-subcategory/?id=
      fetch(
        `${apiUrl.apiUrl.url}/brand/get-brand-by-category?cat_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            brandList: data,
          });

          this.state.brandSelected = [];
          this.state.initialValues.brandId = ["0"];
          this.state.brandSelected.push({ value: 0, label: "All" });

          for (let i = 0; i < data.length; i++) {
            this.state.initialValues.brandId.push(data[i].id);
          }

          console.log(
            this.state.initialValues.brandId,
            "this.state.initialValues.brandId"
          );
          this.setState({});

          this.getAssetsListByBrand();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_city") {

       // unset asset type and asset name
       this.state.brandSelected = [];
       this.state.initialValues.brandId = [];
       this.state.assetTypeSelected = [];
       this.state.initialValues.assetTypeId = [];
       this.state.assetsList = [];
       this.state.initialValues.assetName ="";
       this.state.initialValues.assetId ="";
       this.getAssetTypes();

      //brandName
      this.state.initialValues.cityId = newValue.value;
      this.state.initialValues.cityName = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_status") {
      //brandName
      this.state.initialValues.LeaseStatusId = newValue.value;
      this.state.initialValues.LeaseStatusName = newValue.label;
    } else if (actionMeta == "change_brand") {

      // unset asset type and asset name
      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      this.state.assetsList = [];
      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";

      //brandName

      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.brandSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByBrand();
      this.getAssetTypes();

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-all-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_asset_type") {

      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";

      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.assetTypeId.push(newValue[i].value);
        this.state.assetTypeSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByAssetType();

    } else if (actionMeta == "change_asset_name") {
      //
      this.state.initialValues.assetId = newValue.value;
      this.state.initialValues.assetName = newValue.label;
      this.setMasterPreValues(newValue.value);
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-all-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_month") {
      //change_lease_number
      this.state.initialValues.leaseMonthId = newValue.value;
      this.state.initialValues.leaseMonthId = newValue.label;
    } else if (actionMeta == "change_lease_type") {
      this.state.initialValues.modelId = newValue.value;
      this.state.initialValues.modelValue = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-all-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = "";
          this.state.initialValues.leaseId = "";
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_number") {
      //change_document_type
      // this.state.initialValues.leaseId = newValue.value;
      // this.state.initialValues.leaseValue = newValue.label;
      this.state.leaseSelected = [];
      if (newValue.length == 0) {
        this.state.initialValues.leaseId = "";
        console.log("going to set");
        //this.setState({});
      }
      if (typeof newValue[0] == "undefined") {
        this.state.initialValues.leaseId = "";
        this.setState({})
      } else if (newValue.length == 1 && newValue[0].value == 0) {
        this.state.initialValues.leaseId = [];

        this.state.leaseSelected.push({
          value: newValue[0].value,
          label: newValue[0].label,
        });

        for (let i = 0; i < this.state.leaseList.length; i++) {
          if (this.state.leaseList[i].id != 0) {
            this.state.initialValues.leaseId.push(
              "" + this.state.leaseList[i].id
            );
          }
        }
      } else {
        this.state.initialValues.leaseId = [];
        for (let i = 0; i < newValue.length; i++) {
          this.state.initialValues.leaseId.push("" + newValue[i].value);
          this.state.leaseSelected.push({
            value: newValue[i].value,
            label: newValue[i].label,
          });
        }
      }
      this.setState({});
    } else if (actionMeta == "change_document_type") {
      //
      this.state.initialValues.leaseDocumentTypeId = newValue.value;
      this.state.initialValues.leaseDocumentTypeId = newValue.label;
    } else if (actionMeta == "change_occupier") {
      //brandName
      this.state.initialValues.occupierId = newValue.value;
      this.state.initialValues.occupierName = newValue.label;
    } else if (actionMeta == "change_landloard") {
      //brandName
      this.state.initialValues.landloardId = newValue.value;
      this.state.initialValues.landloardName = newValue.label;
    } else {
      this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.countryName = newValue.label;
    }
    this.setState({});
  };

  getAssetsListByBrand = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-brand-asset-list?brandId=` +
      this.state.initialValues.brandId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-all-lease-list?all=true&brand=` +
      this.state.initialValues.brandId +
      "&asset=" +
      this.state.initialValues.assetId +
      "&brandCategory=" +
      this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeCountry = (newValue, actionMeta) => {
    console.log(newValue.value, "jj");
    this.countryId = newValue.value;
    newValue.label = newValue.label;

    if (newValue.value == "") {
      console.log("country value empty");
      this.state.states = [];
    }

    this.state.initialValues.countryId = newValue.value;
    this.state.initialValues.countryName = newValue.label;

    this.state.initialValues.stateId = "";
    this.state.initialValues.stateName = "";
    this.state.initialValues.districtId = "";
    this.state.initialValues.districtName = "";
    this.state.initialValues.cityId = "";
    this.state.initialValues.cityName = "";

    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/client-profile" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Reports</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Lease Documentation Report</a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            this.state.leaseSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.counter = Math.random();
            this.setState({});
            //console.log(values, "values", this.state.initialValues);
            //resetForm();

            this.state.assetTypeSelected = [];
            this.state.initialValues.assetTypeId = [];
            this.initialiseAllData();
          }}
          onSubmit={(values, actions) => {
            var brand_id = this.state.initialValues.brandId;
            var asset_id = this.state.initialValues.assetId;
            var form_config = this.state.initialValues;

            form_config.expiry_status = true;
            this.setState({ selectedBrand: brand_id });
            this.setState({ selectedAsset: asset_id });
            this.setState({ formConfig: form_config });
            var counter = this.state.counter + 1;
            console.log(counter, "counter", form_config);
            this.setState({ counter: counter });
            console.log(counter, "counter");

            form_config = undefined;
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,

            resetForm,
          }) => (
            <>

              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      <div className="newGridSectionInner">
                        <label>Country</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="countryId"
                            isSearchable="true"
                            onChange={(e) => {
                              this.handleChangeCountry(e, "changecountry");
                            }}
                            value={{
                              label: this.state.initialValues.countryName,
                              value: this.state.initialValues.countryId,
                            }}
                            options={this.state.countries.map((item) => ({
                              label: item.country_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="countryId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Document Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="documentType"
                            onChange={(e) => {
                              this.valueChange(e, "change_document_type");
                            }}
                            value={{
                              label: this.state.initialValues.leaseDocumentTypeId,
                              value: this.state.initialValues.leaseDocumentTypeId,
                            }}
                            options={this.state.leaseDocumentTypeList.map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          <ErrorMessage name="documentType" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>State</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="stateId"
                            onChange={(e) => {
                              this.valueChange(e, "change_state");
                            }}
                            value={{
                              label: this.state.initialValues.state_name,
                              value: this.state.initialValues.state_id,
                            }}
                            options={this.state.states.map((item) => ({
                              label: item.state_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="stateId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Brand Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="brandId"
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_brand");
                            }}
                            isMulti
                            value={this.state.brandSelected}
                            options={this.state.brandList.map((item) => ({
                              label: item.brand_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="brandId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>District</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="districtId"
                            onChange={(e) => {
                              this.valueChange(e, "change_district");
                            }}
                            value={{
                              label: this.state.initialValues.districtName,
                              value: this.state.initialValues.districtId,
                            }}
                            options={this.state.districtList.map((item) => ({
                              label: item.district_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="districtId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Asset Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_type");
                            }}
                            value={this.state.assetTypeSelected}
                            options={this.state.assetTypeList.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                          />
                        </div>
                      </div>

                      

                      <div className="newGridSectionInner">
                        <label>City</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="cityId"
                            onChange={(e) => {
                              this.valueChange(e, "change_city");
                            }}
                            value={{
                              label: this.state.initialValues.cityName,
                              value: this.state.initialValues.cityId,
                            }}
                            options={this.state.cityList.map((item) => ({
                              label: item.city_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="cityId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            onInputChange={this.getAssetsList}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_name");
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetsList.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="assetId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Model Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="modelType"
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_type");
                            }}
                            value={{
                              label: this.state.initialValues.modelValue,
                              value: this.state.initialValues.modelId,
                            }}
                            options={this.state.leaseTypes.map((item) => ({
                              label: item.value,
                              value: item.label,
                            }))}
                          />
                          <ErrorMessage name="modelType" component="div" className="text-red" />
                        </div>
                      </div>

                      {getUserType() == "Landlord" || getUserType() == "" ? (
                        <div className="newGridSectionInner">
                          <label>Occupier</label>
                          <div className="position-relative">
                            <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                              name="occupierId"
                              onChange={(e) => {
                                this.valueChange(e, "change_occupier");
                              }}
                              value={{
                                label: this.state.initialValues.occupierName,
                                value: this.state.initialValues.occupierId,
                              }}
                              options={this.state.occupierList.map((item) => ({
                                label: item.text,
                                value: item.id,
                              }))}
                            />
                          </div>
                        </div>
                      ) : null}

                      {getUserType() == "Occupier" || getUserType() == "" ? (
                        <div className="newGridSectionInner">
                          <label>Landlord Group</label>
                          <div className="position-relative">
                            <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                              name="landloardId"
                              onChange={(e) => {
                                this.valueChange(e, "change_landloard");
                              }}
                              value={{
                                label: this.state.initialValues.landloardName,
                                value: this.state.initialValues.landloardId,
                              }}
                              options={this.state.landloardList.map((item) => ({
                                label: item.text,
                                value: item.id,
                              }))}
                            />
                          </div>
                        </div>
                      ) : null}

                      <div className="newGridSectionInner">
                        <label>Lease Number</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="leaseId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_number");
                            }}
                            value={this.state.leaseSelected}
                            options={this.state.leaseList.map((item) => ({
                              label: item.lease_code,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="leaseId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Cost Center</label>
                        <div className="position-relative">
                          <input
                            className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                            name="costcenter"
                            onChange={(e) => {
                              this.state.initialValues.costCenter = e.target.value;
                              this.setState({});
                            }}
                          />
                          <ErrorMessage name="costCenter" component="div" className="text-red" />
                        </div>
                      </div>

                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="add_button">
                        View
                      </button>
                      <button type="reset" className="reset_button" onClick={(e) => resetForm()}>
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>
        <LeaseDocumentTable
          key={this.state.counter}
          clikekey={
            this.state.selectedBrand +
            "--" +
            this.state.selectedAsset +
            "--" +
            this.state.initialValues.cityId
          }
          asset={this.state.selectedAsset}
          formConfig={this.state.formConfig}
          brand={this.state.selectedBrand}
          expiry_report="true"
          columns={this.state.gridColumns}
          fetchUrl={
            apiUrl.apiUrl.url + "/lease-report/get-all-lease-by-documents?"
          }
        />
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              size="lg"
              className="documentModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <div className="container modalBreadCrumbs">
                    <div className="row">
                      <div className="col-lg-12">
                        <ul>
                          <li>Document</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <ViewLeasePdfReader
                      url={this.state.currentDocument}
                      pageNumber={this.state.pageNo}
                    />
                  </div>
                </div>
              </Modal.Body>
              {/* <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={this.closeModal}
                  >
                    Close
                  </Button>
                </Modal.Footer> */}
            </Modal>
          </div>
        </div>
      </>

    );
  }
}

export default withRouter(LeaseDocumentation);
